import { createContext } from "react";

const VehicleContext = createContext();

export default VehicleContext;
